import SurveyNew from './views/surveyNew';

export default [
    {
        path: '/candidates/new/:evalToken',
        name: 'SurveyNew',
        component: SurveyNew,
    }
];
// {
// children: [
//   {
//     path: 'step1',
//     name: 'RecruiterSightRefsIndex',
//     component: RecruiterSightRefsIndex,
//     meta: {layout: "layoutUser", pageOrder: 2, pageSubOrder: 1},
//   },
//   {
//     path: 'step2',
//     name: 'RecruiterSightRefsIndex',
//     component: RecruiterSightRefsIndex,
//     meta: {layout: "layoutUser", pageOrder: 2, pageSubOrder: 1},
//   },
//   {
//     path: 'step3',
//     name: 'RecruiterSightRefsIndex',
//     component: RecruiterSightRefsIndex,
//     meta: {layout: "layoutUser", pageOrder: 2, pageSubOrder: 1},
//   },
//   {
//     path: 'step4',
//     name: 'RecruiterSightRefsIndex',
//     component: RecruiterSightRefsIndex,
//     meta: {layout: "layoutUser", pageOrder: 2, pageSubOrder: 1},
//   }
// ]